// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion-section {
  margin-top: 4rem;
  padding: 2.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);
}

.suggestion-header {
  max-width: 700px;
  margin-bottom: 2rem;
}

.suggestion-header h2 {
  margin: 0.35rem 0 0.75rem;
  font-size: 2rem;
  line-height: 1.2;
  color: #111827;
}

.suggestion-header > p:last-child {
  margin: 0;
  color: #6b7280;
  line-height: 1.7;
}

.suggestion-form {
  max-width: 800px;
}

.suggestion-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.suggestion-field {
  position: relative;
  margin-bottom: 1.25rem;
}

.suggestion-field label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
}

.suggestion-field label span {
  font-weight: 400;
  color: #9ca3af;
}

.suggestion-field input,
.suggestion-field select,
.suggestion-field textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #111827;
  font: inherit;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.suggestion-field input,
.suggestion-field select {
  height: 46px;
  padding: 0 0.9rem;
}

.suggestion-field textarea {
  min-height: 140px;
  padding: 0.9rem;
  resize: vertical;
}

.suggestion-field input::placeholder,
.suggestion-field textarea::placeholder {
  color: #9ca3af;
}

.suggestion-field input:focus,
.suggestion-field select:focus,
.suggestion-field textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.suggestion-counter {
  margin-top: 0.35rem;
  text-align: right;
  font-size: 0.75rem;
  color: #9ca3af;
}

.suggestion-submit {
  display: flex;
  justify-content: flex-start;
}

.suggestion-submit button {
  min-width: 150px;
  padding: 0.75rem 1.25rem;
  border: 0;
  border-radius: 10px;
  background: #2563eb;
  color: white;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.2s ease;
}

.suggestion-submit button:hover:not(:disabled) {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.suggestion-submit button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.suggestion-feedback {
  margin: 1rem 0 0;
  font-size: 0.9rem;
  font-weight: 500;
}

.suggestion-feedback.sent {
  color: #15803d;
}

.suggestion-feedback.error {
  color: #dc2626;
}

@media (max-width: 650px) {
  .suggestion-section {
    margin-top: 2.5rem;
    padding: 1.5rem;
    border-radius: 16px;
  }

  .suggestion-header h2 {
    font-size: 1.5rem;
  }

  .suggestion-row {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .suggestion-submit button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/suggestionBox/suggestion.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb;;wBAEsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf;;uBAEqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".suggestion-section {\n  margin-top: 4rem;\n  padding: 2.5rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 20px;\n  background: #ffffff;\n  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);\n}\n\n.suggestion-header {\n  max-width: 700px;\n  margin-bottom: 2rem;\n}\n\n.suggestion-header h2 {\n  margin: 0.35rem 0 0.75rem;\n  font-size: 2rem;\n  line-height: 1.2;\n  color: #111827;\n}\n\n.suggestion-header > p:last-child {\n  margin: 0;\n  color: #6b7280;\n  line-height: 1.7;\n}\n\n.suggestion-form {\n  max-width: 800px;\n}\n\n.suggestion-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.suggestion-field {\n  position: relative;\n  margin-bottom: 1.25rem;\n}\n\n.suggestion-field label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.suggestion-field label span {\n  font-weight: 400;\n  color: #9ca3af;\n}\n\n.suggestion-field input,\n.suggestion-field select,\n.suggestion-field textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #111827;\n  font: inherit;\n  outline: none;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.suggestion-field input,\n.suggestion-field select {\n  height: 46px;\n  padding: 0 0.9rem;\n}\n\n.suggestion-field textarea {\n  min-height: 140px;\n  padding: 0.9rem;\n  resize: vertical;\n}\n\n.suggestion-field input::placeholder,\n.suggestion-field textarea::placeholder {\n  color: #9ca3af;\n}\n\n.suggestion-field input:focus,\n.suggestion-field select:focus,\n.suggestion-field textarea:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.suggestion-counter {\n  margin-top: 0.35rem;\n  text-align: right;\n  font-size: 0.75rem;\n  color: #9ca3af;\n}\n\n.suggestion-submit {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.suggestion-submit button {\n  min-width: 150px;\n  padding: 0.75rem 1.25rem;\n  border: 0;\n  border-radius: 10px;\n  background: #2563eb;\n  color: white;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    transform 0.2s ease;\n}\n\n.suggestion-submit button:hover:not(:disabled) {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.suggestion-submit button:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.suggestion-feedback {\n  margin: 1rem 0 0;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.suggestion-feedback.sent {\n  color: #15803d;\n}\n\n.suggestion-feedback.error {\n  color: #dc2626;\n}\n\n@media (max-width: 650px) {\n  .suggestion-section {\n    margin-top: 2.5rem;\n    padding: 1.5rem;\n    border-radius: 16px;\n  }\n\n  .suggestion-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .suggestion-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  .suggestion-submit button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
